import { render, staticRenderFns } from "./Ejemplo.vue?vue&type=template&id=13aa1058&scoped=true&"
import script from "./Ejemplo.vue?vue&type=script&lang=js&"
export * from "./Ejemplo.vue?vue&type=script&lang=js&"
import style0 from "./Ejemplo.vue?vue&type=style&index=0&id=13aa1058&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa1058",
  null
  
)

export default component.exports